// extracted by mini-css-extract-plugin
module.exports = {"title":"UpdateChanges-title-SXJnT"};